var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentView,{tag:"component",attrs:{"transition-mode":"out-in","registrationData":_vm.registrationData},on:{"transitionend":function($event){$event.stopPropagation();},"continue":_vm.next}})}
var staticRenderFns = []

export { render, staticRenderFns }